import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { once } from "~/jose_modern/once.js";
import { Highlighter } from "~/jose_modern/highlighter.js";
import { setCookie } from "~/jose_modern/utils.js";
import { costModeCookie } from "~/recipal-app/controllers/shared/constants.js.erb";

const initializeChart = () => {
  const costElements = document.querySelectorAll("#cost-data span");
  if (costElements.length === 0) {
    return;
  }

  // Grab cost data from page
  const costData = [];
  costElements.forEach((el, index) => {
    const percent = parseFloat(el.getAttribute("data-percent"));
    const className = el.className;

    costData.push({ percent, class: className });
  });

  // Setup SVG
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", "100%");
  svg.setAttribute("height", "100%");
  svg.setAttribute("viewBox", "0 0 100 10");
  svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
  svg.setAttribute("id", "cost-breakdown-svg");

  let xOffset = 0;

  // Create rectangle segments
  costData.forEach((data, index) => {
    const segmentWidth = data.percent;

    const rect = document.createElementNS(svgNS, "rect");
    rect.setAttribute("x", xOffset);
    rect.setAttribute("y", 0);
    rect.setAttribute("width", segmentWidth);
    rect.setAttribute("height", 10);
    rect.setAttribute("class", `segment ${data.class}`);
    // white border between segments
    rect.setAttribute("stroke", "white");
    rect.setAttribute("stroke-width", "0.5");

    rect.addEventListener("mouseenter", () => highlightItem(index));
    rect.addEventListener("mouseleave", clearHighlights);
    rect.addEventListener("click", () => highlightItem(index));

    svg.appendChild(rect);

    xOffset += segmentWidth;
  });

  document.getElementById("cost-breakdown-chart").appendChild(svg);

  const legendItems = document.querySelectorAll(".legend-item");

  legendItems.forEach((item, index) => {
    item.addEventListener("mouseenter", () => highlightItem(index));
    item.addEventListener("mouseleave", clearHighlights);
    item.addEventListener("click", () => highlightItem(index));
  });

  once(document.body, "clear-cost-chart-highlight", () => {
    document.body.addEventListener("click", (ev) => {
      if (!ev.target.closest(".segment") && !ev.target.closest(".legend-item")) {
        clearHighlights();
      }
    });
  });

  function getActiveIndex() {
    const segments = document.querySelectorAll(".segment");
    return Array.from(segments).findIndex((segment) => segment.classList.contains("hovered"));
  }

  function highlightItem(index) {
    const activeIndex = getActiveIndex();
    if (activeIndex === index) {
      return clearHighlights();
    }

    document.querySelectorAll(".segment").forEach((el, i) => {
      if (i === index) {
        el.classList.add("hovered");
        el.classList.remove("dimmed");
      } else {
        el.classList.add("dimmed");
        el.classList.remove("hovered");
      }
    });

    legendItems.forEach((el, i) => {
      if (i === index) {
        el.classList.add("hovered");
        el.classList.remove("dimmed");
      } else {
        el.classList.add("dimmed");
        el.classList.remove("hovered");
      }
    });
  }

  function clearHighlights() {
    document.querySelectorAll(".segment").forEach((el) => {
      el.classList.remove("hovered", "dimmed");
    });

    legendItems.forEach((el) => {
      el.classList.remove("hovered", "dimmed");
    });
  }
};

let costMode = null;
const applyCostMode = (mode) => {
  const section = document.querySelector("#cost-breakdown-section");
  section.dataset.costMode = mode;

  section.querySelectorAll("[data-cost-mode-button]").forEach((button) => {
    const isActive = button.dataset.costModeButton === mode;
    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-pressed", isActive);
  });
};

onViewLoad("recipes#cost", () => initializeChart());
onViewLoad("recipes#cost", () => {
  const panel = document.querySelector("[data-partial='recipes/cost_breakdown']");

  panel.addEventListener("click", (ev) => {
    const button = ev.target.closest("[data-cost-mode-button]");
    if (!button) return;

    costMode = button.dataset.costModeButton;
    setCookie(costModeCookie, costMode);
    applyCostMode(costMode);
  });
});
document.addEventListener("partial:replace", (ev) => {
  if (ev.partial === "recipes/cost_breakdown") {
    if (ev.element.innerHTML === "") {
      document.querySelector("#floating-component").classList.add("is-hidden");
    } else {
      initializeChart();
      if (costMode) applyCostMode(costMode);
      document.querySelector("#floating-component").classList.remove("is-hidden");
      Highlighter.highlight(document.querySelector("#floating-component button"));
    }
  }
});

// Handle moving the cost_breakdown between mobile/tablet+ views
onViewLoad("recipes#cost", () => {
  document.addEventListener("breakpoint:change", ({ name, matches }) => {
    if (name !== "widescreen") {
      return;
    }

    let destination;
    if (matches) {
      destination = document.querySelector("#cost-breakdown-sidebar-anchor");
    } else {
      destination = document.querySelector("#floating-cost-breakdown");
    }

    destination.appendChild(document.querySelector("[data-partial='recipes/cost_breakdown']"));
  });
});

onViewLoad("recipes#cost", () => {
  document.body.addEventListener("click", (ev) => {
    if (!ev.target.classList.contains("recipe-msrp-button")) return;
    ev.preventDefault();

    const container = document.getElementById("recipe_msrp_container");
    if (!container.classList.toggle("is-hidden")) {
      Highlighter.highlight(container);
      container.querySelector("input").focus();
    } else {
      document.getElementById("recipe_msrp").value = null;
    }
  });
});
